import colors from 'shared-tokens/utils/tokens/colors';
import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

import { mainCls as baseCls } from '../../style';

const brpM = createBreakpoint('m');

export const mainCls = `${baseCls}__footer`;

export default {
  [mainCls]: {
    width: '100%',
  },
  [`${mainCls}__btns`]: {
    height: 40,
    [brpM]: {
      height: 32,
    }, 
  },
  [`${mainCls}__auct`]: {
    
    margin: '20px 0 28px',
    [brpM]: {
      margin: '8px 0 18px',
    },
  },
  [`${mainCls}__close`]: {
    marginRight: 8,    
    height: '100%',
    fontSize: 15,    
    paddingRight: 24,
    paddingLeft: 24,
    [brpM]: {
      marginRight: 0,
      paddingRight: 0,
      paddingLeft: 0,
      width: 138,
      fontSize: 14,
      borderColor: `${colors.border.rgba} !important`,
      transition: createTransition(['color', 'border-color']),
      '&:hover': {
        color: `${colors.secondary.rgba} !important`,
        borderColor: `${colors.secondary.rgba} !important`,
      },
    },
  },
  [`${mainCls}__save`]: {
    flexGrow: 1,
    height: '100%',
    fontSize: 15,
    [brpM]: {
      width: 238,
      fontSize: 14,
      transition: createTransition(['background-color', 'border-color']),
      '&:hover': {
        borderColor: '#A30000 !important',
        backgroundColor: '#A30000 !important',
      },
    },
  },
};